import React from 'react';
import tpl from '../templates/kmda';
import BaseNewCardView from '../../../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'Gov.Kmda';
}
